const slick = require('slick-carousel');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PubSub from 'underpub-js';

var InsightsSlider = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

InsightsSlider.prototype.init = function () {

	let self = this;
	
	self.$insightsSlider = self.options.$el.find(`.slider`);

	self.$insightsSlider.slick({
		// speed: 350,
		slidesToShow: 2,
		// infinite: true,
		// arrows: false,
		// dots: false,
		// fade: true,
		autoplay: true,
		autoplaySpeed: 8000,

		responsive: [
			// {
			//   breakpoint: 1024,
			//   settings: {
			// 	slidesToShow: 3,
			// 	slidesToScroll: 3,
			// 	infinite: true,
			// 	dots: true
			//   }
			// },
			{
			  breakpoint: 768,
			  settings: {
				slidesToShow: 1
			  }
			}
		]
	});

	self.options.$el.find(`.dots-nav .dot`).on('click', function() {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		$(this).addClass('active');

		var slideNumber = $(this).data('slideNumber');

		self.$insightsSlider.slick('slickGoTo', slideNumber - 1);

	});

	this.$insightsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		self.options.$el.find(`[data-slide-number="${nextSlide+1}"]`).addClass('active');

	});

};

export default InsightsSlider;
